import { Box, Skeleton } from "@mui/material";
import workspacesTokens from "../Workspaces.tokens";
import { listRowSx } from "../Workspaces.styles";

const { list } = workspacesTokens;

interface Props {
  /** The list's own grid, so the placeholder rows land on the real columns. */
  columns: string;
  /** Widths of the text cells between the name and the action cell. */
  middleCells: string[];
  /** false for a read-only list with no action column (e.g. Enrollment). */
  showAction?: boolean;
  /** Rows to draw; defaults to the list's usual count. */
  rows?: number;
}

/**
 * Loading rows shaped like the list's real rows (same row style, same grid),
 * so nothing jumps when the data lands.
 */
const WorkspaceListSkeleton = ({
  columns,
  middleCells,
  showAction = true,
  rows = list.skeletonRows,
}: Props) => (
  <>
    {Array.from({ length: rows }, (_, index) => (
      <Box key={index} aria-hidden="true" sx={listRowSx(columns, index === rows - 1)}>
        <Skeleton variant="text" width="45%" sx={{ fontSize: list.font.rowText }} />
        {middleCells.map((width, cell) => (
          <Skeleton
            key={cell}
            variant="text"
            width={width}
            sx={{ fontSize: list.font.rowText }}
          />
        ))}
        {showAction && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", ml: "auto" }}>
            <Skeleton
              variant="rounded"
              width={list.actionSize}
              height={list.actionSize}
            />
          </Box>
        )}
      </Box>
    ))}
  </>
);

export default WorkspaceListSkeleton;
